export const formatPrice = (price: number): string => {
  const maxFrac = price < 1_000_000 ? 1 : 2;
  const nf = new Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
    maximumFractionDigits: maxFrac,
  });
  return nf.format(price);
};

export const listingsNumberFormatter = (listingsNumber: number): string => {
  const nf = new Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
    maximumFractionDigits: 2,
  });
  return nf.format(listingsNumber);
};

export const mapListingsClusterNumberFormatter = (
  listingsNumber: number
): string => {
  const maxFrac =
    (listingsNumber < 1_000_000 && listingsNumber > 100_000) ||
    (listingsNumber < 1_000_000_000 && listingsNumber > 10_000_000)
      ? 1
      : 2;
  const nf = new Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
    maximumFractionDigits: 2,
  });
  return nf.format(listingsNumber);
};

export function getClusterSize(listingsNumber: number): number {
  if (listingsNumber >= 10_000_000) {
    return 56;
  } else if (listingsNumber >= 1_000_000) {
    return 52;
  } else if (listingsNumber >= 100_000) {
    return 48;
  } else if (listingsNumber >= 10_000) {
    return 42;
  } else if (listingsNumber >= 1_000) {
    return 38;
  }
  return 34;
}
